import type { ReactNode } from 'react'
import LinkIcon from './LinkIcon'

type TeamCardProps = {
  name: string
  role: string
  image?: ReactNode
  imageSrc?: string
  linkedInUrl: string
}

function TeamCard({ name, role, image, imageSrc, linkedInUrl }: TeamCardProps) {
  return (
    <article className="flex flex-col gap-6 md:gap-4">
      <div className="h-[367px] overflow-hidden rounded-none bg-gray-light md:h-[420px]">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={name}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          image
        )}
      </div>
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-[18px] font-medium leading-[26px] text-black">
            {name}
          </h3>
          <p className="text-body-sm font-archivo font-light text-gray-dark">
            {role}
          </p>
        </div>
        <a
          href={linkedInUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`LinkedIn profile for ${name}`}
          className="inline-flex items-center justify-center"
        >
          <span className="sr-only">LinkedIn</span>
          <LinkIcon className="h-10 w-10" />
        </a>
      </div>
    </article>
  )
}

export default TeamCard
